import { useCallback, useState } from "react";
import { downloadFile } from "@/utils/downloadFile";
import { downloadBillingInvoicePdf } from "../api/downloadBillingInvoicePdf/downloadBillingInvoicePdfApi";

export function useBillingInvoicePdfDownload() {
  const [downloadingInvoiceId, setDownloadingInvoiceId] = useState<
    string | null
  >(null);

  const downloadInvoicePdf = useCallback((id: string) => {
    setDownloadingInvoiceId(id);

    downloadBillingInvoicePdf(id)
      .then(({ blob, fileName }) => downloadFile(blob, fileName))
      .finally(() => setDownloadingInvoiceId(null));
  }, []);

  return {
    downloadingInvoiceId,
    downloadInvoicePdf,
  };
}